export default __webpack_public_path__ + "static/media/grey arrow.70001893.svg";